<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/fntbVt/tc-custom/9781497627208.jpg?1708805380716" alt="This image is the cover for the book Into the Out Of"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Into the Out Of
      </h1>
      <p class="bookDescription body article font2">
        <b>Demonic spirit-beings are stealing into our world in this fantasy adventure from the #1<i> New York Times</i>–bestselling author of <i>The Damned Trilogy</i>.</b><br/><br/> Earth is being invaded by the shetani—-spirit creatures so small and stealthy that only one man knows about the increasing peril. The potential savior is an African elder named Olkeloki who is capable of fighting evil both in this world and the spirit one. But to be successful he must recruit the help of two others: government agent Joshua Oak and a feisty young woman named Merry Sharrow. Only the three of them can keep the shetani from destroying reality as we know it. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alan Dean Foster
      </h2>
      
      <p class="authorDescription body article">The&#160;<I>New York Times</I>&ndash;bestselling author of more than one hundred ten books, Alan Dean Foster is one of the most prominent writers of modern science fiction. Born in New York City in 1946, he studied filmmaking at UCLA, but first found success in 1968 when a horror magazine published one of his short stories. In 1972 he wrote his first novel,&#160;<I>The Tar-Aiym Krang</I>, the first in his Pip and Flinx series featuring the Humanx Commonwealth, a universe he has explored in more than twenty-five books. He also created the Spellsinger series, numerous film novelizations, and the story for&#160;<I>Star Trek: The Motion Picture.</I>&#160;An avid world traveler, he lives with his family in Prescott, Arizona.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?bf4a4a7c